<div [ngClass]="{ 'inline-elements': inline == true }">
  <mat-form-field [ngClass]="classes" class=" date">
    <mat-label>{{startDateHeading}}</mat-label>
    <input matInput [matDatepicker]="picker1" required [placeholder]="startDateHeading" [formControl]="startDateControl" (dateChange)="dateSelected()" (focus)="openPicker1(picker1)" (click)="openPicker1(picker1)" #elementToFocuss>
    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
    <mat-datepicker #picker1></mat-datepicker>
    @if (!startDateControl.hasError('required')) {
<mat-error>Invalid date</mat-error>
}
    @if (startDateControl.hasError('required')) {
<mat-error>You must make a selection</mat-error>
}
  </mat-form-field><br/>
  @if (time) {
<mat-form-field class="split-input time">
  <mat-label>{{_label}}</mat-label>
    <input placeholder="{{ _label }} Time" matInput [formControl]="startTimeControl"
           [ngxTimepicker]="darkPicker" readonly>
    <ngx-material-timepicker #darkPicker [format]="24" (timeSet)="startTimeChanged($event)"></ngx-material-timepicker>
</mat-form-field>
}
  <mat-form-field [ngClass]="classes" class="date">
    <mat-label>{{endDateHeading}}</mat-label>
    <input matInput [matDatepicker]="picker2" required [placeholder]="endDateHeading" [formControl]="endDateControl" (dateChange)="dateSelected()" (focus)="openPicker2(picker2)" (click)="openPicker2(picker2)" #elementToFocus>
    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
    <mat-datepicker #picker2></mat-datepicker>
    @if (endDateControl.hasError('required')) {
<mat-error>You must make a selection</mat-error>
}
    @if (endDateControl.hasError('notMatched')) {
<mat-error>The end date is before the start date.</mat-error>
}
  </mat-form-field>
  @if (time) {
<mat-form-field class="split-input time">
  <mat-label>{{_label}}</mat-label>
    <input placeholder="{{ _label }} Time" matInput [formControl]="endTimeControl"
           [ngxTimepicker]="darkPicker" readonly>
    <ngx-material-timepicker #darkPicker [format]="24" (timeSet)="endTimeChanged($event)"></ngx-material-timepicker>
</mat-form-field>
}
</div>